/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path appbar
 * @description App bar for the system

 * @section 4.2.1
 * @section 4.2.1.5
 * @section 4.2.1.4
 *
 */
import { useState } from "react";
import { AppBarContextInterface } from "./BusinessPortalAppBarContext";
type Period = {
  name: string;
};
const useAppBar = (): AppBarContextInterface => {
  const [language, setLanguageValue] = useState("en");
  const [showAppBar, setShowAppBar] = useState(true);
  const [showPeriodSelector, setShowPeriodSelector] = useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState<Period | undefined>();
  const setLanguage = (value: string): void => {
    setLanguageValue(value);
  };
  const setAppBar = (value: boolean): void => {
    setShowAppBar(value);
  };
  const setPeriodSelector = (value: boolean): void => {
    setShowPeriodSelector(value);
  };
  const setPeriod = (value: Period): void => {
    setSelectedPeriod(value);
  };
  const getPeriodName = (): string => selectedPeriod?.name || "current";
  return {
    language,
    setLanguage,
    showAppBar,
    setAppBar,
    selectedPeriod,
    setPeriod,
    showPeriodSelector,
    setPeriodSelector,
    getPeriodName,
  };
};
export default useAppBar;
